import {toLower} from '@servicenow/ui-internal';

/**
 * Returns a string representing the host element, i.e. `<sn-component component-id="123" />`
 * @private
 * @param {host} host
 * @returns {string}
 */
function getComponentName(host) {
	return `<${toLower(host.tagName)} component-id="${host.getAttribute('component-id')}" />`;
}

export default getComponentName;
